import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUser, isAuthenticated, isDeviceEnrolled } from '../utils';
import { PATH } from './PATH';
import { getRoleHomePath } from './roleHome';

/**
 * Guards the seller-select + PIN screen. It needs an enrolled terminal to load a
 * roster — a not-enrolled terminal is sent to **enrollment**; an already
 * signed-in user is sent to their role home (POS for a seller, management for a
 * branch admin). Otherwise the screen renders.
 */
export const SellerLoginRoute: React.FC = () => {
    if (!isDeviceEnrolled()) {
        return <Navigate replace to={PATH.ENROLL} />;
    }
    if (isAuthenticated()) {
        return <Navigate replace to={getRoleHomePath(getUser()?.role)} />;
    }
    return <Outlet />;
};
